import Bugsnag from "@bugsnag/js";

const API_KEY = "1d7add347f1562e7ec9907b732ee9d19";

export function initErrorTracker() {
  if (process.env.NODE_ENV === "development") {
    return;
  }
  Bugsnag.start({
    apiKey: API_KEY,
    appVersion: process.env.PLATFORM_VERSION,
    releaseStage:
      process.env.ENV === "primary" ? "production" : process.env.ENV,
    metadata: {
      client: process.env.CLIENT,
      clientVersion: process.env.CLIENT_CONFIG_VERSION,
      branch: process.env.BRANCH,
    },
  });
}



// WEBPACK FOOTER //
// ./src/common/utilities/errorTracker.js